module.exports = __webpack_public_path__ + "img/fatalIcon.04777640.png";